import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        const token = localStorage.getItem("access_token");
        if (!token) {
            setUser(false);
            setLoading(false);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            localStorage.removeItem("access_token");
            setUser(false);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { checkAuth(); }, [checkAuth]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        if (data.token) {
            localStorage.setItem("access_token", data.token);
        }
        setUser(data);
        return data;
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
        localStorage.removeItem("access_token");
        localStorage.removeItem("admin_token");
        setUser(false);
    };

    const impersonate = async (userId) => {
        const { data } = await api.post(`/admin/impersonate/${userId}`);
        if (data.token) {
            localStorage.setItem("access_token", data.token);
        }
        if (data.admin_token) {
            localStorage.setItem("admin_token", data.admin_token);
        }
        setUser(data);
        return data;
    };

    const stopImpersonation = async () => {
        const adminToken = localStorage.getItem("admin_token") || "";
        const { data } = await api.post("/admin/stop-impersonation", { admin_token: adminToken });
        if (data.token) {
            localStorage.setItem("access_token", data.token);
        }
        localStorage.removeItem("admin_token");
        setUser(data);
        return data;
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, checkAuth, impersonate, stopImpersonation }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
